/**
 * Token 读写
 * - Access Token：短效，请求头携带
 * - Refresh Token：长效，仅用于 /refresh，无痕续期
 */

import { TOKEN_KEY, REFRESH_TOKEN_KEY, USER_INFO_KEY } from '@/config/constants'
import { getStorage, setStorage, removeStorage } from '@/utils/storage'

export function getToken(): string {
  return getStorage<string>(TOKEN_KEY) ?? ''
}

export function setToken(token: string): void {
  setStorage(TOKEN_KEY, token)
}

export function getRefreshToken(): string {
  return getStorage<string>(REFRESH_TOKEN_KEY) ?? ''
}

export function setRefreshToken(token: string): void {
  setStorage(REFRESH_TOKEN_KEY, token)
}

export function setTokenPair(accessToken: string, refreshToken: string): void {
  setToken(accessToken)
  setRefreshToken(refreshToken)
}

/** 本地是否仍有登录凭证（Access 或 Refresh 任一存在） */
export function hasStoredSession(): boolean {
  return !!(getToken() || getRefreshToken())
}

export function clearToken(): void {
  removeStorage(TOKEN_KEY)
  removeStorage(REFRESH_TOKEN_KEY)
}

/** 清除登录态（Token + 本地用户快照，不含设备 ID） */
export function clearAuthSession(): void {
  clearToken()
  removeStorage(USER_INFO_KEY)
}
